// Contact.js
import React, { useState } from 'react';
import './Contact.css';
import phone from '../Assets/phone.png';
import location from '../Assets/location.png';
import email from '../Assets/email.png';
import facebook from '../Assets/facebook.png';
import twitter from '../Assets/twitter.png';
import instagram from '../Assets/instagram.png';
import { FormSubmissionError, submitContactMessage } from '../services/siteFormsApi';

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  const sendMessage = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setIsSuccess(false);
    setIsError(false);
    setErrorText('');

    const fd = new FormData(e.target);
    const name = fd.get('name');
    const emailVal = fd.get('email');
    const message = fd.get('message');

    try {
      await submitContactMessage({
        name: typeof name === 'string' ? name : '',
        email: typeof emailVal === 'string' ? emailVal : '',
        message: typeof message === 'string' ? message : '',
      });
      setIsSuccess(true);
      e.target.reset();
    } catch (err) {
      const msg =
        err instanceof FormSubmissionError
          ? err.message
          : err?.message || 'There was an error sending your message.';
      setErrorText(msg);
      setIsError(true);
    } finally {
      setIsSubmitting(false);
      setTimeout(() => {
        setIsSuccess(false);
        setIsError(false);
        setErrorText('');
      }, 5000);
    }
  };

  return (
    <div className='maincontactpagecontainer'>
      <div className='heroSection'>
        Contact Us
      </div>
      <div className='contactfirstdiv'>
        <br /> <br />
        <div className='gridbox'>
          <div className='phonebox'>
            <div className='imgdiv'><img src={phone} alt='Phone icon' className='contacticon' /></div><br />Phone
            <div className='contactdetails'><br />+233(0)24-712-5235</div>
            <div className='contactdetails'>+233(0)20-122-1507</div>
          </div>
          <div className='officebox'>
            <div className='imgdiv'><img src={location} alt='Location icon' className='contacticon' /></div><br />Location
            <br />
            <div className='contactdetails'><br />Opintinse Street, Kotobabi, Accra Ghana</div>
          </div>
          <div className='mailbox'>
            <div className='imgdiv'><img src={email} alt='Email icon' className='contacticon' /></div><br />Email
            <br />
            <div className='contactdetails'><br/>gettydenkyi@<wbr/>volunteersimpactinitiative.<wbr/>org</div>
          </div>
        </div>
        <br /> <br />
      </div>

      <div className="full-width-contact-container">
        <div className="full-width-contact-page">
          <h4 className="full-width-contact-title">Kindly send us a message using this form</h4>
          {isSuccess && (
                <div className="full-width-response-message success">
                  Your message has been sent successfully!
                </div>
              )}

              {isError && (
                <div className="full-width-response-message error">
                  {errorText || 'Failed to send message. Please try again later.'}
                </div>
              )}
          <form onSubmit={sendMessage} className="full-width-contact-form">
            <div className="full-width-form-grid">
              <div className="full-width-form-column">
                <div className="full-width-form-group">
                  <input
                    type="text"
                    id="user_name"
                    name="name"
                    placeholder="Enter your Name"
                    required
                    className="full-width-form-input"
                  />
                </div>
                <div className="full-width-form-group">
                  <input
                    type="email"
                    id="user_email"
                    name="email"
                    placeholder="Enter a valid email address"
                    required
                    className="full-width-form-input"
                  />
                </div>
              </div>

              <div className="full-width-form-column">
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Enter your message"
                    required
                    className="full-width-form-textarea"
                  />
              </div>

            </div>

            <div className="full-width-form-submit-container">
              <button
                type="submit"
                className={`full-width-submit-button ${isSubmitting ? 'submitting' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="full-width-button-loading">
                    <svg className="full-width-spinner" viewBox="0 0 24 24">
                      <circle className="full-width-spinner-circle" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="full-width-spinner-path" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Processing...
                  </span>
                ) : (
                  "Send Message"
                )}
              </button>

            </div>
          </form>
        </div>
      </div>

       <div className='socialmediacontainer'>
        <div className='socialmedia'>
          <a href='https://www.facebook.com/VolunteersImpactInitiative/'><div className='socialmediagridbox'><img src={facebook} alt='Facebook' className='socialicon' /></div></a>
          <a href='https://www.twitter.com'><div className='socialmediagridbox'><img src={twitter} alt='Twitter' className='socialicon' /></div></a>
          <a href='https://www.instagram.com'><div className='socialmediagridbox'><img src={instagram} alt='Instagram' className='socialicon' /></div></a>
        </div>

        <div style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 20, fontFamily: 'Arial' }}><br />Connect With Us Using Our Social Media Handles And Take A Look At Our Productive Endeavours</div>
      </div>


    </div>
  );
};

export default Contact;
